<ng-container *ngIf="message.length > 0">
  <div [ngClass]="{ 'error-active': message.length > 0 }" class="form-control-validation-error d-flex">
    <svg role="img" viewBox="0 0 24 24" class="me-1 flex-shrink-0">
      <title>{{ ('status_error' | translate) + ':' }}</title>
      <use xlink:href="#exclamation-square"></use>
    </svg>
    <p>{{ message }}</p>
  </div>
</ng-container>
